module.exports = __webpack_public_path__ + "img/YP.af92a961.png";